<template>
    <FormLayoutRow>
        <FormLayoutLabel
            text="eventcreate.sourceevent"
            tooltip="eventcreate.sourceeventtooltip"
        ></FormLayoutLabel>
        <DropdownSelect
            :show-search="true"
            class="flex-fill"
            v-model="model"
            :data="computedEventDatasource"
            search-type="ContainsAll"
            :virtualScrollerMaxItems="30"
        />
    </FormLayoutRow>
</template>
<script setup lang="ts">
import { DropdownSelect } from '@/components';
import { FormLayoutLabel, FormLayoutRow } from '@/components/Form';
import type { SelectLine } from '@/objects';
import { EventinfoBase } from '@/objects/generated';
import { formatDateDefault } from '@/utilities/dateutils';
import { computed } from 'vue';

const model = defineModel<number | null>({ required: true });

const props = withDefaults(
    defineProps<{
        /**
         * Contains a list of events we can select as a source for contestants
         */
        eventslist: EventinfoBase[] | null;

        /**
         * If true, a "none" option will be added to the select list.
         * @default true
         */
        addNoneOption?: boolean;
    }>(),
    {
        addNoneOption: true,
    },
);

/**
 * We create a select datasource for the events list.
 */
const computedEventDatasource = computed(() => {
    if (!props.eventslist) {
        return [];
    }

    const events = props.eventslist.map((x) => ({ text: x.Name, value: x.ID, subtext: formatDateDefault(x.Date, 'DATE') }) as SelectLine);

    if (props.addNoneOption) {
        events.unshift({ text: 'general.none', value: null, separator: true } as SelectLine);
    }

    return events;
});
</script>
